"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1239 5.62195C20.7403 5.62195 25.3171 10.2551 25.3171 16C25.3171 21.7449 20.7403 26.3781 15.1239 26.3781V28.061C21.696 28.061 27 22.6479 27 16C27 9.35214 21.696 3.93903 15.1239 3.93903C10.0787 3.93903 5.77935 7.13157 4.05595 11.6185L5.62698 12.2219C7.11394 8.35055 10.8118 5.62195 15.1239 5.62195Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.68292 10.6707V5.34146H4V11.5122C4 11.9769 4.37673 12.3537 4.84146 12.3537H10.4512V10.6707H5.68292Z"
})));
module.exports = exports.default;